import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.213 13.655a.645.645 0 0 0 .559.974h14.456a.645.645 0 0 0 .56-.974L9.72 1.54A.84.84 0 0 0 9 1.125a.84.84 0 0 0-.72.415L1.212 13.655Zm-.97-.57L7.309.97a1.96 1.96 0 0 1 3.382 0l7.066 12.115a1.773 1.773 0 0 1-1.53 2.665H1.773a1.773 1.773 0 0 1-1.53-2.665M9 4.5c.31 0 .563.253.563.563v4.5a.565.565 0 0 1-.563.562.564.564 0 0 1-.563-.563v-4.5c0-.309.254-.562.563-.562m-.844 7.875a.844.844 0 1 1 1.687 0 .844.844 0 0 1-1.687 0"
    }, null, -1)
  ])))
}
export default { render: render }